import { useState } from 'react';
import Icon from '../forms/icon.component';

interface VideoModalProps {
  nameVideo: string;
  titleLink: string;
}

const VideoModal: React.FC<VideoModalProps> = ({ nameVideo, titleLink }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <div className="d-flex">
      <span className="fs-5 text-gray-700 mt-3">
        El costo de envío de esta plantilla está sujeto a ciertas
      </span>{' '}
      <button
        className="btn btn-link link fs-5 fw-bolder cursor-pointer menu-link ms-2 text-primary fw-bolder"
        onClick={(e) => {
          e.preventDefault();
          handleShow();
        }}
      >
        {titleLink}
      </button>
      {show && (
        <div className="bg-video-overlay">
          <div className="video-container">
            <button onClick={handleClose} className="video-close-button" type="button">
              <Icon icon="ki-abstract-11" size="fs-2" type="white" />
            </button>
            <video controls autoPlay loop muted className="video-player">
              <source src={`/assets/media/video/${nameVideo}.mp4`} type="video/mp4" />
              Tu navegador no soporta el tag de video.
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoModal;
